import { baseAPIRequest } from 'utilities/http';

import { baseURI } from './config';

async function postUpVoteQuestion (id) {

	try {

		const url = `${baseURI}/questions/${id}/voteup/`;
		const response = await baseAPIRequest({
			url,
			params: { method: 'POST' }
		});
		if (!response.isSuccess) {

			const [ error ] = response.errors;
			throw new Error(`Failed to upvote question: ${error.message}`);

		}
		return response;

	} catch (error) {

		// eslint-disable-next-line no-console
		console.error(error.message);
		throw Error;

	}

}

export default postUpVoteQuestion;
